
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.104 17.8c0 .033.004.117.013.25a2.082 2.082 0 01-.032.625.414.414 0 01-.127.244.388.388 0 01-.26.081H4.648a3.535 3.535 0 01-2.577-1.057C1.357 17.24 1 16.391 1 15.4V6.6c0-.992.357-1.84 1.07-2.544A3.536 3.536 0 014.647 3h4.052c.11 0 .204.04.284.119.08.079.12.173.12.28 0 .034.005.118.013.25a2.078 2.078 0 01-.032.625.413.413 0 01-.126.245.386.386 0 01-.26.08H4.648c-.557 0-1.034.197-1.431.588A1.913 1.913 0 002.62 6.6v8.8c0 .55.198 1.02.595 1.412.397.392.874.588 1.43.588h3.951l.146.012c.097.009.145.021.145.038 0 .016.034.04.102.068.067.03.097.067.088.113a.322.322 0 00.026.169zm11.653-7.44a.763.763 0 01.243.563.762.762 0 01-.243.564L13.793 18.3a.796.796 0 01-.576.238.796.796 0 01-.576-.238.762.762 0 01-.243-.563V14.13H6.663a.798.798 0 01-.576-.238.762.762 0 01-.243-.564v-4.81c0-.217.08-.405.243-.563a.797.797 0 01.576-.238h5.735V4.109c0-.217.08-.405.243-.563a.797.797 0 01.576-.238c.222 0 .414.08.576.238l6.964 6.813z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_menu_logout.svg